import {
    TEAMDASHBOARDSCREEN_LOAD,
    TEAMDASHBOARDSCREEN_UNLOAD,
    TEAMDASHBOARDSCREEN_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
    //Overall page
    //ticketCountOverTimeStats
    //jibeProgressOverTimeStats
    //responseOverTimeStats

    //Breakdowns
    //ticketCountOverTimeByBreakdownStats
    //jibeProgressBreakdownOverTimeStats
    //responseBreakdownOverTimeStats

    //reasonsForContact
    //userTeamsStats

    //--------Examples:
    //jibeProgressOverTimeStats:
    //[
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 76,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "02/12/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "02/12/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 76,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "02/19/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "02/19/2024 00:00:00"
    //    },
    //]

    //ticketCountOverTimeStats
    //[
    //    {
    //        "tickets": 624,
    //        "agentSurveys": 596,
    //        "customerSurveys": 82,
    //        "compliance": 0,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 539,
    //        "agentSurveys": 500,
    //        "customerSurveys": 48,
    //        "compliance": 0,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 397,
    //        "agentSurveys": 378,
    //        "customerSurveys": 20,
    //        "compliance": 0,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 177,
    //        "agentSurveys": 155,
    //        "customerSurveys": 21,
    //        "compliance": 0,
    //        "dateIndex": 4,
    //        "windowStart": "04/01/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 14,
    //        "agentSurveys": 13,
    //        "customerSurveys": 2,
    //        "compliance": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    }
    //]

    //responseOverTimeStats
    //[
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 319,
    //        "sumQuestionEffectiveResponses": 558,
    //        "customerResponseCnt": 56,
    //        "sumCustomerResponses": 79,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 240,
    //        "sumQuestionEffectiveResponses": 558,
    //        "customerResponseCnt": 23,
    //        "sumCustomerResponses": 79,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 357,
    //        "sumQuestionEffectiveResponses": 527,
    //        "customerResponseCnt": 43,
    //        "sumCustomerResponses": 58,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 171,
    //        "sumQuestionEffectiveResponses": 527,
    //        "customerResponseCnt": 15,
    //        "sumCustomerResponses": 58,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 270,
    //        "sumQuestionEffectiveResponses": 453,
    //        "customerResponseCnt": 38,
    //        "sumCustomerResponses": 45,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 184,
    //        "sumQuestionEffectiveResponses": 453,
    //        "customerResponseCnt": 7,
    //        "sumCustomerResponses": 45,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 288,
    //        "sumQuestionEffectiveResponses": 408,
    //        "customerResponseCnt": 29,
    //        "sumCustomerResponses": 36,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 120,
    //        "sumQuestionEffectiveResponses": 408,
    //        "customerResponseCnt": 7,
    //        "sumCustomerResponses": 36,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 178,
    //        "sumQuestionEffectiveResponses": 344,
    //        "customerResponseCnt": 11,
    //        "sumCustomerResponses": 19,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 167,
    //        "sumQuestionEffectiveResponses": 344,
    //        "customerResponseCnt": 8,
    //        "sumCustomerResponses": 19,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 208,
    //        "sumQuestionEffectiveResponses": 297,
    //        "customerResponseCnt": 9,
    //        "sumCustomerResponses": 15,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 90,
    //        "sumQuestionEffectiveResponses": 297,
    //        "customerResponseCnt": 6,
    //        "sumCustomerResponses": 15,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //]

    //ticketCountOverTimeByBreakdownStats:
    //[
    //    {
    //        "tickets": 3038,
    //        "agentSurveys": 0,
    //        "customerSurveys": 0,
    //        "compliance": 0,
    //        "dateIndex": 3,
    //        "windowStart": "03/25/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 1406,
    //        "agentSurveys": 0,
    //        "customerSurveys": 0,
    //        "compliance": 0,
    //        "dateIndex": 4,
    //        "windowStart": "04/01/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "tickets": 226,
    //        "agentSurveys": 0,
    //        "customerSurveys": 0,
    //        "compliance": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    }
    //]

    //jibeProgressBreakdownOverTimeStats
    //[
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 40,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "game_feedback"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 57,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "game_feedback"
    //    },
    //    //other dateIndex
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 40,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "game_feedback"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 57,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "game_feedback"
    //    },
    //]

    //responseBreakdownOverTimeStats
    //[
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 2,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 1,
    //        "windowStart": "04/03/2024 00:00:00",
    //        "aggregationId": 2,
    //        "aggregationName": "purchase_activation"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 1,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 1,
    //        "windowStart": "04/03/2024 00:00:00",
    //        "aggregationId": 2,
    //        "aggregationName": "purchase_activation"
    //    },

    //    //other dateIndex

    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 4,
    //        "sumQuestionEffectiveResponses": 6,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 2,
    //        "windowStart": "04/04/2024 00:00:00",
    //        "aggregationId": 2,
    //        "aggregationName": "purchase_activation"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 2,
    //        "sumQuestionEffectiveResponses": 6,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 2,
    //        "windowStart": "04/04/2024 00:00:00",
    //        "aggregationId": 2,
    //        "aggregationName": "purchase_activation"
    //    },
    //]
};

const handlers = {
    [TEAMDASHBOARDSCREEN_LOAD]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [TEAMDASHBOARDSCREEN_UNLOAD]: () => initialState,
    [TEAMDASHBOARDSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
